// ** React Imports
import React, { Fragment, forwardRef } from "react";
import Chart from "chart.js";

// ** Reactstrap Imports
import { Row, Col } from "reactstrap";
import { Bar } from "react-chartjs-2";
import moment from 'moment'

// Images
import logo from '../../../assets/images/logo.png'


const PdfReportPage = forwardRef((props, ref) => {
    const dimensionData = props?.dimensionData;
    const indicatorData = props?.indicatorData;
    const profileData = props?.profileData;
    const ESGperformanceData = props?.ESGperformanceData;
    const optionalQuesData = props?.optionalQuesData;
    const requiredQuestions = props?.requiredQuestions;

    const colorLeval = [
        {
            leval: "Laggard",
            color_code: "#FF0000"
        },
        {
            leval: "Beginner",
            color_code: "#FF9900"
        },
        {
            leval: "Intermediate",
            color_code: "#B6D7A8"
        },
        {
            leval: "Advanced",
            color_code: "#93C47D"
        },
        {
            leval: "Leader",
            color_code: "#38761D"
        },
    ];

    return (
        <Fragment>
            <div ref={ref} className={`container px-4 pdfFont ${props.pdfContent ? 'd-block' : 'd-none'}`}>
                {/* <div ref={ref} className='container px-4 pdfFont'> */}
                {/* <div ref={ref} className='container px-4 pdfClass'> */}
                {/* {props?.printing &&
                    <div className="d-flex justify-content-between mb-3">
                        <h2 className="pt-3">ESG MATURITY REPORT</h2>
                        <img src={logo} alt="logo" width={300} />
                    </div>
                } */}
                <div className="d-flex justify-content-between mb-3">
                    {/* <div className="d-flex justify-content-between mb-3 position-fixed top-0 overflow-auto"> */}
                    <h2 className="pt-3">ESG MATURITY REPORT</h2>
                    <img src={logo} alt="logo" width={300} />
                </div>
                <div className="profile">

                    <Row className="profile px-5 pt-4">
                        <Col className="" md="6" sm="12">
                            <p>
                                Date : <span className="bold">{moment(profileData?.updatedAt).format("DD-MM-YYYY")}</span>
                            </p>
                            <p>
                                Company Name : <span className="bold">{profileData?.company}</span>
                            </p>
                            <p>Company Registration Number : <span className="fw-bold">{profileData?.companyReg}</span></p>
                        </Col>
                        <Col className="" md="6" sm="12">
                            <p>
                                Industry : <span className="bold">{profileData?.industry?.name}</span>
                            </p>
                            {/* <p className="mb-0">
                                Company Registration Number : <span className="fw-bold">{profileData?.companyReg}</span>
                            </p> */}
                        </Col>
                        <hr></hr>
                    </Row>

                    <Row className="profile px-5 mb-4">
                        <Col className="" md="6" sm="12">
                            <p>
                                ESG Maturity Level : <span className="fw-bold" style={{ color: colorLeval.find(item => item.leval === ESGperformanceData?.leval)?.color_code }}>{ESGperformanceData?.leval}</span>
                            </p>
                            <p>
                                Environmental Maturity Level :{" "}
                                <span className="fw-bold" style={{ color: colorLeval.find(item => item.leval === dimensionData[0]?.leval)?.color_code }}>
                                    {dimensionData[0]?.leval}
                                </span>
                            </p>
                        </Col>
                        <Col className="" md="6" sm="12">
                            <p className="mb-0">
                                Social Maturity Level : <span className="fw-bold" style={{ color: colorLeval.find(item => item.leval === dimensionData[1]?.leval)?.color_code }}>{dimensionData[1]?.leval}</span>
                            </p>
                            <p className="mb-0">
                                Governance Maturity Level : <span className="fw-bold" style={{ color: colorLeval.find(item => item.leval === dimensionData[2]?.leval)?.color_code }}>{dimensionData[2]?.leval}</span>
                            </p>
                        </Col>
                    </Row>

                </div>


                <Row className="justify-content-evenly">
                    <Col
                        className="history-text-color px-0 mb-4 mb-md-0"
                        md="5"
                        sm="12"
                    >
                        <h4 className="ps-3 pt-2 mb-4">Score of Category</h4>
                        <div className="mt-5 d-flex justify-content-center align-items-center">
                            <Bar className="ps-1 pe-2 chart-wrapper" data={props.data} options={props.options} height={150}></Bar>
                        </div>
                    </Col>
                    <Col className="history-text-color px-0" md="6" sm="12">
                        <div>
                            <h4 className="ps-3 pt-2 mb-4">Score of Indicator</h4>
                            <table className="table border">
                                <thead className="table-head">
                                    <tr>
                                        <td scope="col">Dimension</td>
                                        <td scope="col">Indicator</td>
                                        <td scope="col" className="text-center">
                                            Your Score
                                        </td>
                                        <td scope="col" className="text-center">
                                            Peer Score
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    {indicatorData?.length > 0 && [...new Set(indicatorData.map(item => item?.dimension?._id))].map((it, ind) => {
                                        return (
                                            indicatorData?.filter(item => item?.dimension?._id === it).map((item, index) => (
                                                <tr key={index}>
                                                    {index === 0 && <td rowSpan={indicatorData?.filter(item => item?.dimension?._id === it).length} style={{ backgroundColor: '#f4fbfe' }}>{item?.dimension?.name ? `${item?.dimension?.name}` : '--'}</td>}

                                                    <td className="">{item.name ? `${item?.name}` : '--'}</td>
                                                    <td className="text-center">{item?.correct ? `${((item?.correct / item?.total) * 100).toFixed(2)}%` : '--'}</td>
                                                    <td className="text-center">{item?.industryScore ? `${((item?.industryScore / item?.total) * 100).toFixed(2)}%` : '--'}</td>
                                                </tr>

                                            )))
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>

                <Row className="border mt-5" >
                    <h4 className="pt-3 px-5">Peer Comparison Bar</h4>
                    <div className="mt-5">
                        {/* <Bar className="ps-1 pe-4" data={props.horizontalData} options={props.horoizontalOptions}></Bar> */}
                        <Bar style={{ marginRight: '10rem', paddingRight: '5rem' }} data={props.horizontalData} options={props.horoizontalOptions}></Bar>
                    </div>
                </Row>

                <Row className="mt-5">
                    <h4 className="pt-2 mb-4 fw-bold">ESG performance</h4>
                    <h4 className="pt-2 textColor">{profileData?.company} has an {ESGperformanceData?.leval} level</h4>
                    <p className="pt-2 mb-4">{ESGperformanceData?.data?.esgDescription.replace("SME X", profileData?.company)}</p>

                    <h5><hr></hr></h5>
                </Row>

                {dimensionData?.length > 0 && dimensionData?.map((dimensionItem, dimensionIndex) => (
                    <Row className="mt-5">
                        <h4 className="pt-2 mb-4 fw-bold">{dimensionItem?.dimension} performance</h4>
                        <h4 className="pt-2 textColor">{profileData?.company} has an {dimensionItem?.leval} level</h4>
                        <p className="pt-2 mb-4">{dimensionItem?.performance?.description.replace("SME X", profileData?.company)}</p>
                        <h5 className="pt-2 fw-bold">The company undertakes the following activities on {dimensionItem?.dimension} topics:</h5>

                        {optionalQuesData?.length > 0 && optionalQuesData?.map((optItem, optIndex) => (
                            <Row className="mt-1">

                                {dimensionItem?.dimension === optItem?.dimension ? <>

                                    {optItem?.questons?.filter(itemInd => itemInd.questions?.length > 0 && itemInd?.questions?.filter(item => item.answer.length > 0)).map((itemInd, indexInd) => (

                                        <div className="ps-4 mb-2">
                                            {itemInd?.questions?.filter(item => item?.answer?.length > 0).map((itemQ, indexQ) => (
                                                <div className="">
                                                    {indexQ === 0 && <p>{itemInd.indicater}</p>}
                                                    <p key={indexQ} className="">{indexInd + 1}.{indexQ + 1}. {itemQ?.answer.join(', ')}</p>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </> : <></>}

                            </Row>
                        ))}

                        <h5><hr></hr></h5>
                    </Row>
                ))}

                <Row className="profile">
                    <h4 className="pt-2 mb-4 fw-bold">SDG MAPPING</h4>

                    <div className="px-2">
                        <div className="row">
                            {indicatorData?.length > 0 && indicatorData?.map((item, index) => (
                                <div key={index} className="col-md-4 mb-4">
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <h5 className="card-title textColor">{item?.name ? `${item?.name}` : '--'}</h5>
                                            <p className="card-text">{item?.performance?.description ? `${item?.performance?.description?.replace("SME X", profileData?.company)}` : '--'}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Row>
                <Row className="profile">
                    <h4 className="pt-2 mt-2 fw-bold">SUBMISSION DETAILS</h4>
                    {requiredQuestions?.length > 0 && requiredQuestions?.map((optItem, optIndex) => (
                        <Row className="mt-1">

                            {Object.values(optItem?.questons).some(el => el.questions.length > 0) ? <>
                                <h4 className="pt-2 mb-4 mt-2 fw-bold">{optItem?.dimension}</h4>
                            </> : <></>}
                            {optItem?.questons?.map((itemInd, indexInd) => (

                                <div className="ps-4 ms-2">
                                    {itemInd?.questions?.length > 0 ? <h4 className="textColor mt-2" key={indexInd}>{itemInd?.indicater}:</h4> : <></>}

                                    {itemInd?.questions?.length > 0 && itemInd?.questions?.map((itemQ, indexQ) => (
                                        <div className="">
                                            <p key={indexQ}>{indexQ + 1}. {itemQ?.questionId?.question} </p>
                                            <p key={indexQ} className="ps-3"> {itemQ?.answer.join(', ')}</p>
                                        </div>
                                    ))}
                                </div>

                            ))}
                        </Row>
                    ))}

                </Row>
                <h4 className="pt-2 mb-4 fw-bold">DISCLAIMER</h4>
                <p style={{ fontSize: '.5rem' }}>
                    The ESG maturity levels and score calculations provided on this website are based on self-declared data submissions by <span className="textColor">{profileData?.company}</span>. The information provided in this report shall not be relied upon as a substitute for professional advice. <span className="textColor">UNGCNSA</span> shall not be held liable for any errors, omissions, or inaccuracies in the data provided by <span className="textColor">{profileData?.company}</span> or for any actions taken in reliance on such information. <span className="textColor">{profileData?.company}</span> is solely responsible for the accuracy and completeness of the information they provide.
                </p>

            </div>
        </Fragment>
    )
})

export default PdfReportPage